import React from 'react'
import { Link } from 'gatsby'
import cx from 'clsx'
import { makeStyles } from '@material-ui/core/styles'

// Containers
import Layout from '~2021/containers/Layout'

// Components
import Seo from '~2021/components/Seo'

// Styles
const useStyles = makeStyles((theme) => ({
  btn: {
    '&:hover, &:focus': {
      color: `rgb(${theme.palette.white})`,
    },
    color: `rgb(${theme.palette.silver})`,
    fontSize: '0.875rem',
    letterSpacing: '0.11em',
    textDecoration: 'none',
    textTransform: 'uppercase',
    transition: `color ${theme.transitions.duration.shortest}ms ${theme.transitions.easing.easeIn}`,
  },
  fourohfour: {
    textAlign: 'center',
  },
  subTitle: {
    fontSize: '1.5rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2rem',
    },
  },
  text: {
    fontSize: '1.1rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.5rem',
    },
  },
  title: {
    fontSize: '3rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '7rem',
    },
  },
}))

const FourOhFour = () => {
  const classes = useStyles()
  return (
    <Layout>
      <Seo title="404: Not found" page="404" />
      {/* Spacer */}
      <div style={{ height: 100 }}></div>
      <section className={cx(classes.fourohfour)}>
        <h1 className={cx(classes.title)}>404</h1>
        <p className={cx(classes.text)}>
          Well, that’s awkward.
          <br />
          Let’s find you some Fandoms.
        </p>
        <Link className={cx(classes.btn)} to="/">
          Return Home
        </Link>
      </section>
    </Layout>
  )
}

export default FourOhFour
